module.exports = __webpack_public_path__ + "img/20190521115541微信截图_20190521115235.0170b73a.png";